import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ImplementDetailsService } from '../implement-details/implement-details.service';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { GenericIdName, SchematicDataVM, ComponentVM } from '../setup-implement/setup-implement.model';
import { AppService } from '../../../app.service';
import { AddObservationPointModal } from './add-observation-point-modal';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { componentListsVM } from '../equipment-details/equipment-details.model';

@Component({
    selector: 'add-observation-point',
    templateUrl: './add-observation-point.component.html',
    styleUrls: ['./add-observation-point.component.scss']
})
export class AddObservationPointComponent implements OnInit {

    constructor(
        public _moduleService: ImplementDetailsService,
        private _implementService: SetupImplementService,
        private _appService: AppService,
        private _sanitizer: DomSanitizer,
        public toastr: NotificationsService) { }
    @Output() closeObservationWindow: EventEmitter<number> = new EventEmitter();
    @Output() NewobservationPointId: EventEmitter<number> = new EventEmitter();

    componentList: ComponentVM[]
    componentList_: ComponentVM[]
    observationLists: GenericIdName[] = [];
    oldGETUri: string;
    toppings = new FormControl();
    noOfReading: number = 1
    limitNew: number=0
    limitWorn: number=0
    limitRange:number;
    measurement:number;

    TypeID: number
    componentId: number
    isValid: boolean
    Compname: string
    Qname: string
    Qdesc: string

    ObservationID: any
    OPQuestionImage: string
    isCommentSelect: number = 0
    isImageSelect: number = 0
    checkedAnswe: boolean = false
    checkedImage: boolean = false
    show: boolean = true
    OPId: number
    IsImage:boolean;
    IsAnswer:boolean;
    @Input() cusID: number;
    @Input() implementID: number;
    @Input() positionX: number
    @Input() positionY: number
    @Input() schematicID: SchematicDataVM;
    @Input() showOPWindow: boolean;

    sToolTip_NoOfReadings: string = "If your observation point does not require a measurement please set No. of Readings to 0.";
    InspectionTypeID:number
    ///
    ngOnInit() {
        this.checkHasEnableSelection();
        this.checkHasEnablePassFail();
        this.checkHasEnableYesNo();

        this.loadComponentList();
        this.loadObservationLists();
        this.getInspectionTypeList();
    }
enableSelection:boolean=false;
enablePassFail:boolean=false;
enableYesNo:boolean=false;


    checkHasEnableSelection(){
        this._appService.getApplicationConfigValue("EnableSelectionObservationType").subscribe(result => {
           if(result=="1"){
               this.enableSelection=true;
           }else{
            this.enableSelection=false;
           }
        })
    }
    checkHasEnablePassFail(){
        this._appService.getApplicationConfigValue("EnablePassFailObservationType").subscribe(result => {
           if(result=="1"){
               this.enablePassFail=true;
           }else{
            this.enablePassFail=false;
           }
        })
    }
    checkHasEnableYesNo(){
        this._appService.getApplicationConfigValue("EnableYesNoObservationType").subscribe(result => {
           if(result=="1"){
               this.enableYesNo=true;
           }else{
            this.enableYesNo=false;
           }
        })
    }
    gotoObservationListPage() {
        this._appService.getApplicationConfigValue("oldGETUri").subscribe(result => {
            this.oldGETUri = result;

            if (this.cusID <= 0) {
                window.open(this.oldGETUri + 'GET/SelectObservationListCustomer.aspx', '');
            }
            else {
                window.open(this.oldGETUri + 'GET/ManageObservationLists.aspx?cu=' + this.cusID, '');
            }


        });
    }


    onCloseClick(): void {
        this.closeObservationWindow.emit(this.OPId);

    }


    loadComponentList() {
        //this._moduleService.returnComponentsForGET(this.implementID.toString()).subscribe(res => {

        this._implementService.ReturnGETComponents(this.implementID).subscribe(result => {
            this.componentList = result
        }, error => { console.log(error); });
    }

    //observationLists: GenericIdName[] = [];
    loadObservationLists() {
        this._implementService.GetObservationLists(this.cusID, this.implementID).subscribe(r => {
            this.observationLists = r;
        });
    }

    saveObservation() {
        this.isValid = true
        let checknoispositive = this.noOfReading % 1;
        //console.log(this.componentId)

        //check NO of Reading is Positive and less than 5
        if ((this.noOfReading % 1) != 0) {
            this.toastr.error("Please enter a whole number for Number of Readings")
            this.isValid = false
        }
        if (this.noOfReading > 5) {
            this.toastr.error("Number of Readings must be less than 5")
            this.isValid = false
        }
        if (this.TypeID == null || this.TypeID == 0) {
            this.toastr.error("Please select type ")
            this.isValid = false
        }


        //check Measurement Type Validation
        if (this.TypeID == 1 && this.isFECRNormal==false) {
            if (this.noOfReading == 0 || this.noOfReading == null) {
                if (this.limitNew != null || this.limitWorn != null) {
                    this.toastr.error("Can not enter values for the Limits")
                    this.isValid = false
                }
            }
            else {
                if (this.limitNew == null || this.limitWorn == null) {
                    this.toastr.error("Please enter Limits")
                    this.isValid = false
                }
                // else if(this.limitNew !=0 ||this.limitWorn !=0){
                  else   if (this.limitNew <= this.limitWorn) {
                        this.toastr.error("Limit-NEW must greater than the Limit-WORN.")
                        this.isValid = false
                    }
              //  }
               
            }
        }
        else if (this.TypeID == 1 && this.isFECRNormal==true) {
            this.noOfReading = 1;
            this.limitWorn = null;
        }
     
        else if (this.TypeID== 2 && this.isFECRCrack==true) {
            if (this.noOfReading == 0 || this.noOfReading == null) {
                if (this.measurement != null ) {
                    this.toastr.error("Can not enter value for the measurement")
                    this.isValid = false
                }
            }
            else {
                if (this.measurement == null) {
                    this.toastr.error("Please enter Measurement")
                    this.isValid = false
                }
            }
        }
        else if(this.TypeID== 2 && this.isFECRCrack==false){
            if (this.noOfReading == 0 || this.noOfReading == null) {
                if (this.limitNew != null || this.limitWorn != null) {
                    this.toastr.error("Can not enter values for the Limits")
                    this.isValid = false
                }
            }
            else {
                if (this.limitNew == null || this.limitWorn == null) {
                    this.toastr.error("Please enter Limits")
                    this.isValid = false
                }
                else if (this.limitNew >= this.limitWorn) {
                    this.toastr.error("Limit-WORN must greater than the Limit-NEW.")
                    this.isValid = false
                }
            }

        }

        //check component is selected
        if (this.componentId <= 0 || this.componentId == undefined) {

            this.toastr.error("You must select a component to add an Observation")
            this.isValid = false
        }

        
        if (this.Compname == null) {
            this.toastr.error("Please enter Observation Name");
            this.isValid = false
        }

        if (this.isValid == true) {

            this.saveObservationPoint();
        }

    }


    saveObservationPoint() {

        if(this.isFECRCrack==true){
            this.TypeID = 7
        }else  if(this.isFECRNormal){
            this.TypeID=8
        }
        var saveParams: AddObservationPointModal = new AddObservationPointModal();
        saveParams.Name = this.Compname;
        saveParams.ComponentID = this.componentId;
        saveParams.ObservationList = this.ObservationID
        saveParams.QuestionImage = this.OPQuestionImage
        saveParams.OPTypeId = this.TypeID
        saveParams.NoOfReadings = this.noOfReading
        saveParams.LimitsNew = this.limitNew
        saveParams.LimitsScrap = this.limitWorn
        saveParams.Comment = this.isCommentSelect
        saveParams.Image = this.isImageSelect
        saveParams.positionX = this.positionX
        saveParams.positionY = this.positionY
        saveParams.schematicId = this.schematicID.Id
        saveParams.Qname=this.Qname
        saveParams.Qdesc=this.Qdesc
        saveParams.LimitRange=this.limitRange
        saveParams.Measurement =this.measurement
        saveParams.isCrackFixed=false;
        saveParams.InspectionTypeID=this.InspectionTypeID
        saveParams.ImplementID=this.implementID
        saveParams.IsImage =this.checkedImage;
        saveParams.IsAnswer=this.checkedAnswe;

        this._moduleService.SaveObservationPoint(saveParams).subscribe((res: any) => {

            if (res > 0) {
                this.OPId = res
                this.toastr.success("Observation saved successfully!");
                this.closeObservationWindow.emit(this.OPId);
                this.NewobservationPointId.emit(res);
                this.reset();
            }
            else {
                this.toastr.error("Observation name already exists.");
            }

        })

    }
    ChangeIsAnswer(valeu){
       
this.checkedAnswe =valeu
    }
    ChangeIsImage(valeu){
      
        this.checkedImage =valeu

    }
    ///reset fields
    reset() {
        this.Compname = "";
        this.componentId = 0;
        this.ObservationID = 0
        this.OPQuestionImage = ""
        this.TypeID = 0
        this.noOfReading = 0
        this.limitNew = 0
        this.limitWorn = 0
        this.Qdesc=""
        this.Qname=""
    }


    //upload OPQuestion Image

    selectedFile: File
    ModelImage_fromPC: string
    onSelectOPQuestionImage(event: any) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            this.selectedFile = event.target.files[0];
            reader.onloadend = (e) => {
                this.uploadPhoto(reader.result as string);

            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    uploadPhoto(newPhoto: string) {
        this.ModelImage_fromPC = newPhoto.split(",")[1];
        this.OPQuestionImage = this.ModelImage_fromPC;
    }

    sanitize(image: string) {
        return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
    }

    checkMaxReading() {
        if (this.noOfReading > 5) {
            this.noOfReading = 5
        }
        if (this.noOfReading <= 0) {
            this.noOfReading = 0
        }
    }
    checkPositive() {
        if (this.limitNew < 0) {
            this.limitNew = 0;
        }
        if (this.limitWorn < 0) {
            this.limitWorn = 0;
        }
    }

    // ValidateNumberInputs(e) {
    //     if (e.keyCode != 8 && e.keyCode != 0 && (e.keyCode < 48 || e.keyCode > 57)) {
    //         return false;
    //     }
    // }

    ValidateNumberInputs(e) {

        if (e.keyCode != 8 && e.keyCode != 0 && (e.keyCode < 48 || e.keyCode > 57)) {
                 return false;
        }

        // Allow Backspace (keyCode 8) and Delete (keyCode 46)
        if (e.keyCode == 8 || e.keyCode == 46) {
          return true;
        }
      
        // Allow digits (keyCode 48 to 57)
        if (e.keyCode >= 48 && e.keyCode <= 57) {
          // Check if there's already a decimal point in the input
          const inputValue = e.target.value;
          const decimalPointIndex = inputValue.indexOf('.');
          
          // Allow the input if there's no decimal point or the decimal point is not yet entered
          if (decimalPointIndex === -1 || inputValue.substring(decimalPointIndex + 1).indexOf('.') === -1) {
            return true;
          }
        }
      
        // Prevent all other key presses
        return false;
      }
      
    toggleFECRCrack(event:any)
    {
        //console.log("event", event)
        if(event.value){

        }
    }
    isNormal:boolean=true
    isCrack:boolean=false
    isDisabled:boolean=false;
    isFECRCrack:boolean=false;
    isFECRNormal:boolean=false;
    changeType(event:any){
        //console.log("type", this.TypeID, event.target,event)
        if(event.value==3 || event.value==4 ||event.value==5 || event.value==6){
            this.isDisabled=true;
            this.isFECRCrack=false;
            this.isFECRNormal=false;
            this.limitNew=0
            this.limitWorn=0
            this.isNormal=true;
            this.isCrack=false;
        }
        else{
            this.isDisabled=false;
            this.isFECRCrack=false;
            this.isFECRNormal=false;
            this.limitNew=0
            this.limitWorn=0

        }
        if(event.value ==1){
            this.isNormal=true
            this.isCrack=false;
        }
        if(event.value ==2){
            this.isCrack=true;
            this.isNormal=false
        }
        
    }

    
InspectionTypeList:componentListsVM[]
getInspectionTypeList(){
  this._implementService.getInspectionTypeList().subscribe(res=>{
      this.InspectionTypeList=res

  })
}

onchangeComponent(event){
    console.log(event.value)
    this.componentList_= this.componentList.filter(f=>f.Id==event.value)
    if(this.componentList_[0].UOM==2){
        if(this.componentList_[0].MaxCrackLength >0){
            var val =Math.round(this.componentList_[0].MaxCrackLength*25.4)
            this.limitWorn=val
        }
        
    }
    else{
        this.limitWorn =this.componentList_[0].MaxCrackLength 
    }
     
}

}

